import { type FC, type ReactNode } from "react";
import classNames from "classnames";
import { Card, type CardProps } from "~/features/configurator/Linear/components/Card";

export const SASection: FC<{ className?: string; id?: string; children?: ReactNode }> = ({ className, ...rest }) => {
  return <div className={classNames("scha__sa__section", className)} {...rest} />;
};

export const SASectionTitle = ({ className, ...rest }: JSX.IntrinsicElements["h3"]) => (
  <h3 className={classNames("scha__sa__section__title", className)} {...rest} />
);

export const SASectionDescription = ({ className, ...rest }: JSX.IntrinsicElements["div"]) => (
  <div className={classNames("scha__sa__section__description", className)} {...rest} />
);

export const SASectionContents = <T extends keyof JSX.IntrinsicElements>({ className, ...rest }: CardProps<T>) => {
  // @ts-ignore
  return <Card className={classNames("scha__sa__section__contents", className)} disableHover={true} {...rest} />;
};
